export enum mnemonicType {
    encryption = 'encryption',
    signing = 'signing'
}
